import * as z from "zod";
import {
  CommonMetadataSchema,
  type ManifestValidationResult,
  validateManifest,
} from "./_shared.js";

export const ContractManifestSchema = z.looseObject({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  license: z.string().optional(),
  metadata: CommonMetadataSchema.optional(),
});

export type ContractManifest = z.infer<typeof ContractManifestSchema>;

export function validateContract(data: unknown): ManifestValidationResult<ContractManifest> {
  return validateManifest(ContractManifestSchema, data);
}
